import { defineMessages } from 'react-intl';
import type { MessageDescriptor } from 'react-intl';

type MessageKey = 'fileDescriptionLabel' | 'fileDescriptionPlaceholder';

const messages: Record<MessageKey, MessageDescriptor> = defineMessages({
  fileDescriptionLabel: {
    id: 'form.builder.upload.field.textarea.label',
    description: 'Label for File Description Text Area',
    defaultMessage: 'Description of file(s) uploaded',
  },
  fileDescriptionPlaceholder: {
    id: 'form.builder.upload.field.textarea.placeholder',
    description: 'Placeholder for File Description Text Area',
    defaultMessage: 'Enter a description',
  },
});

export default messages;
